import React, { useEffect } from 'react';
import { removeChatingoArtifacts } from './ChatWidgetLoader';

const UnauthedChatCleanup = () => {
  useEffect(() => {
    removeChatingoArtifacts();
  }, []);
  return null;
};

export default UnauthedChatCleanup; 